// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"HistoryTable_tableWrapper_32sL4"};